import { initialEntityDrawer } from "us.collection/constants";
import { IInitialState } from "../Interfaces";

export const initialState: IInitialState = {
  drawer: initialEntityDrawer
};
